import { render, staticRenderFns } from "./workOrderDetail.vue?vue&type=template&id=3b576644&scoped=true"
import script from "./workOrderDetail.vue?vue&type=script&lang=js"
export * from "./workOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./workOrderDetail.vue?vue&type=style&index=0&id=3b576644&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b576644",
  null
  
)

export default component.exports